export const VerificationStatus = {
  Authorization: `initial`,
  Authorizing: `third-party-authorizing`,
  Authorized: `authorized`,
}
